export const MOVE_TO_ANOTHER_ACCOUNT_REQUEST = "MOVE_TO_ANOTHER_ACCOUNT_REQUEST";
export const MOVE_TO_ANOTHER_ACCOUNT_RESULT = "MOVE_TO_ANOTHER_ACCOUNT_RESULT";
export const MOVE_TO_ANOTHER_ACCOUNT_OPEN_MODAL = "MOVE_TO_ANOTHER_ACCOUNT_OPEN_MODAL";
export const MOVE_TO_ANOTHER_ACCOUNT_CLOSE_MODAL = "MOVE_TO_ANOTHER_ACCOUNT_CLOSE_MODAL";
export const MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_REQUEST = "MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_REQUEST";
export const MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_RESULT = "MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_RESULT";

export const MOVE_TO_ANOTHER_ACCOUNT_SET_DEVICE = "MOVE_TO_ANOTHER_ACCOUNT_SET_DEVICE";

